import React from "react";
import {
  ColorIcon,
  getCdnImageSrc,
  HStack,
  VStack,
  customEvent,
  GoiLogo,
  Image,
  colors,
  VLine,
} from "goi_common";
import { Box } from "@chakra-ui/react";
import FixedSubmitButton from "@/components/common/FixedSubmitButton";
import { useRouter } from "next/router";
import ConsultPhoneSubmitSection from "@/components/consult/ConsultPhoneSubmitSection";

export default function NewIntroduce() {
  const router = useRouter();

  return (
    <VStack width="100%" alignItems="center" padding="0px 0 100px">
      <VStack width="100%" maxWidth="480px">
        <HeroSection />

        <GovernmentVerifiedSection />
        <VLine
          width="100%"
          height="16px"
          color={colors.gray50}
          margin="40px 0 0"
        />
        <SafeAdvancePaymentSection />
        <SolvencyRatioSection />
        <VentureInvestmentSection />
        <VLine
          width="100%"
          height="16px"
          color={colors.gray50}
          margin="40px 0 0"
        />
        <MostChosenSection />
        <BestBrandAwardSection />
        <ChoiceOfFamiliesSection />
        <TossPartnerSection />
        <VLine
          width="100%"
          height="16px"
          color={colors.gray50}
          margin="40px 0"
        />
        <ThreePromisesSection />

        <VStack
          width="100%"
          alignItems="center"
          padding="30px 10px 60px"
          background={colors.warmGray100}
        >
          <ConsultPhoneSubmitSection trigger="회사 소개 페이지" />
        </VStack>

        <FixedSubmitButton
          onClick={() => {
            customEvent({
              newGtm: {
                path: "introduce",
                trigger_and_target: "CTA-uv_home",
              },
            });
            router.push("/");
          }}
        >
          고이와 함께 장례 준비 시작하기
        </FixedSubmitButton>
      </VStack>
    </VStack>
  );
}

const HeroSection = () => {
  return (
    <VStack width="100%">
      <VStack
        padding="360px 20px 40px"
        gap="0px"
        css={{
          background: `linear-gradient(180deg, rgba(44, 39, 38, 0.00) 40%, #000000 99.35%), url(${getCdnImageSrc(
            "direct/introduce/hero-2.png"
          )})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
        position="relative"
      >
        <Box css={{ position: "absolute", top: "20px", left: "20px" }}>
          <GoiLogo size={40} color="white" />
        </Box>
        <h1 className="head_32_b white">
          고이 상조,
          <br />
          믿고 맡기는 안심
        </h1>
      </VStack>
    </VStack>
  );
};

const GovernmentVerifiedSection = () => {
  return (
    <>
      <VStack width="100%" padding="40px 20px" background="white" gap="20px">
        <Box className="head_24_b">
          정부가 검증한
          <br /> 소비자 중심 기업
        </Box>
        <Box className="body_16_m gray700">
          삼성전자, LG전자와 함께
          <br /> 소비자중심경영(CCM) 인증을 받았습니다.
        </Box>
      </VStack>
      <VStack
        width="100%"
        alignItems="center"
        padding="26px"
        background={colors.gray50}
      >
        <Image
          src={getCdnImageSrc("direct/introduce/ex-1.png")}
          alt="government-verified-1"
          width="144px"
        />
      </VStack>
    </>
  );
};

const SafeAdvancePaymentSection = () => {
  return (
    <>
      <VStack width="100%" padding="40px 20px" background="white" gap="20px">
        <Box className="head_24_b">
          제1금융권이 지키는
          <br /> 안전한 선수금
        </Box>
        <Box className="body_16_m gray700">
          고객님의 소중한 선수금은
          <br /> 제1금융권 국민은행에 안전하게 보관됩니다.
        </Box>
      </VStack>

      <VStack
        width="100%"
        alignItems="center"
        padding="26px"
        background={colors.gray50}
      >
        <Image
          src={getCdnImageSrc("direct/introduce/ex-2.png")}
          alt="government-verified-1"
          width="144px"
        />
      </VStack>
    </>
  );
};

const SolvencyRatioSection = () => {
  return (
    <VStack
      width="100%"
      padding="40px 20px"
      background="white"
      alignItems="center"
      gap="20px"
    >
      <VStack gap="10px" width="100%">
        <Box
          width="48px"
          height="48px"
          borderRadius="4px"
          background={colors.gray50}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={getCdnImageSrc("direct/introduce/logo-1.png")}
            alt="government-verified-1"
            width="36px"
          />
        </Box>
        <Box className="head_24_b">지급여력비율 2,003%</Box>
        <Box className="body_16_m gray700">업계 평균 대비 10배 더 안전</Box>
      </VStack>
      <Box
        width="100%"
        padding="20px"
        background="#F5F5F5"
        borderRadius="8px"
        className="body_14_m"
      >
        <HStack gap="8px" css={{ marginBottom: "8px" }}>
          <ColorIcon name="infoquestion" color="#666" size="16px" />
          <Box className="body_14_b">지급여력비율이란?</Box>
        </HStack>
        <Box className="body_14_m gray700">
          고객님이 맡긴 돈을 들려드릴 수 있는 재정적 능력을 나타내는 수치입니다.
          높을 수록 보험금 지급 능력이 우수함을 의미합니다.
        </Box>
      </Box>
      <VLine
        width="100%"
        height="1px"
        color={colors.gray100}
        margin="0px 0 0"
      />
    </VStack>
  );
};

const VentureInvestmentSection = () => {
  return (
    <VStack
      width="100%"
      padding="20px 20px"
      background="white"
      alignItems="center"
      gap="20px"
    >
      <VStack gap="10px" width="100%">
        <Box
          width="48px"
          height="48px"
          borderRadius="4px"
          background={colors.gray50}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={getCdnImageSrc("direct/introduce/logo-2.png")}
            alt="government-verified-1"
            width="36px"
          />
        </Box>
        <Box className="head_24_b">업계 최초 벤처투자 119억+</Box>
        <Box className="body_16_m gray700">
          대기업과 투자기관이 인정한 성장성
        </Box>
      </VStack>
    </VStack>
  );
};

const MostChosenSection = () => {
  return (
    <>
      <VStack width="100%" padding="40px 20px" background="white" gap="20px">
        <Box className="head_24_b">
          가장 많이 선택받는
          <br /> 대한민국 대표 상조
        </Box>
        <Box className="body_16_m gray700">
          대한민국에서 가장 많은 분들이 이용하는
          <br /> 장례 정보 플랫폼을 운영합니다.
        </Box>
      </VStack>
      <VStack
        width="100%"
        alignItems="center"
        padding="26px"
        background={colors.gray50}
      >
        <Image
          src={getCdnImageSrc("direct/introduce/ex-3.png")}
          alt="government-verified-1"
          width="144px"
        />
      </VStack>
    </>
  );
};

const BestBrandAwardSection = () => {
  return (
    <VStack width="100%" padding="40px 20px 20px" background="white" gap="20px">
      <VStack gap="10px">
        <Box
          width="48px"
          height="48px"
          borderRadius="4px"
          background={colors.gray50}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={getCdnImageSrc("direct/introduce/logo-3.png")}
            alt="government-verified-1"
            width="36px"
          />
        </Box>
        <Box className="head_24_b">2025 대한민국 최고브랜드 대상</Box>
        <Box className="body_16_m gray700">
          장례 서비스 부문 5년 연속 최고브랜드 대상
        </Box>
      </VStack>
      <VLine
        width="100%"
        height="1px"
        color={colors.gray100}
        margin="0px 0 0"
      />
    </VStack>
  );
};

const ChoiceOfFamiliesSection = () => {
  return (
    <VStack width="100%" padding="20px 20px" background="white" gap="20px">
      <VStack gap="10px">
        <Box
          width="48px"
          height="48px"
          borderRadius="4px"
          background={colors.gray50}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={getCdnImageSrc("direct/introduce/logo-4.png")}
            alt="government-verified-1"
            width="36px"
          />
        </Box>
        <Box className="head_24_b">전국 18만 가족의 선택</Box>
        <Box className="body_16_m gray700">
          18만 가족이 안심하고 선택한 장례 동반자, 고이
        </Box>
      </VStack>
      <VLine
        width="100%"
        height="1px"
        color={colors.gray100}
        margin="0px 0 0"
      />
    </VStack>
  );
};

const TossPartnerSection = () => {
  return (
    <VStack width="100%" padding="20px 20px" background="white" gap="20px">
      <VStack gap="10px">
        <Box
          width="48px"
          height="48px"
          borderRadius="4px"
          background={colors.gray50}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={getCdnImageSrc("direct/introduce/logo-5.png")}
            alt="government-verified-1"
            width="36px"
          />
        </Box>
        <Box className="head_24_b">앱인 토스와 제휴한 상조 파트너</Box>
        <Box className="body_16_m gray700">
          토스 앱에서 직접 만나는 안심 상조 안내 서비스
        </Box>
      </VStack>
    </VStack>
  );
};

const ThreePromisesSection = () => {
  return (
    <VStack width="100%" padding="40px 20px" background="white" gap="20px">
      <Box className="head_24_b">
        고이가 약속하는 <b className="orange650">3가지</b>
      </Box>

      <VStack
        width="100%"
        gap="20px"
        background={colors.gray50}
        padding="20px 0"
        borderRadius="12px"
      >
        <Box width="100%" padding="20px" borderRadius="6px">
          <HStack gap="12px">
            <Box
              css={{
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                background: colors.gray900,
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              1
            </Box>
            <Box className="subtitle_18_b" marginBottom="8px">
              언제든 전액 환급
            </Box>
          </HStack>
          <Box className="body_14_m gray700" marginLeft="34px">
            가입 후 언제든지 100% 환급이 가능합니다.
          </Box>
        </Box>
        <Box width="100%" padding="20px" borderRadius="12px">
          <HStack gap="12px">
            <Box
              css={{
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                background: colors.gray900,
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              2
            </Box>
            <Box className="subtitle_18_b" marginBottom="8px">
              전국 동일 서비스
            </Box>
          </HStack>
          <Box className="body_14_m gray700" marginLeft="34px">
            전국 200개의 제휴 장례식장에서 동일한 품질로 모십니다.
          </Box>
        </Box>
        <Box width="100%" padding="20px" borderRadius="12px">
          <HStack gap="12px">
            <Box
              css={{
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                background: colors.gray900,
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "4px",
                fontWeight: "700",
                fontSize: "14px",
              }}
            >
              3
            </Box>
            <Box className="subtitle_18_b" marginBottom="8px">
              투명한 가격
            </Box>
          </HStack>
          <Box className="body_14_m gray700" marginLeft="34px">
            계약서에 명시된 금액 외 추가 비용은 절대 없습니다.
          </Box>
        </Box>
      </VStack>
    </VStack>
  );
};
